// https://www.abrahamberg.com/blog/aspnet-signalr-and-react/
import * as signalR from '@microsoft/signalr';
const URL = process.env.REACT_APP_BASE_URL ?? 'http://localhost:5000';

export class WebhookConnector {
    private connection: signalR.HubConnection;
    /** Subscribes to dispatch updates; returns a function that unsubscribes. */
    public events: (onUpdated: (date: string, id: string) => void) => () => void;
    static instance: WebhookConnector;
    private userId: string;
    constructor(userId: string) {
        this.userId = userId;
        this.connection = new signalR.HubConnectionBuilder().withUrl(`${URL}/hub`).withAutomaticReconnect().build();

        this.startConnection();

        this.events = (onUpdated) => {
            const handler = (date: string, id: string) => {
                onUpdated(date, id);
            };
            this.connection.on('updated', handler);
            return () => this.connection.off('updated', handler);
        };
    }

    public static getInstance(userId): WebhookConnector {
        if (!WebhookConnector.instance) {
            WebhookConnector.instance = new WebhookConnector(userId);
        }
        return WebhookConnector.instance;
    }

    public stopConnection() {
        try {
            if (this.connection.state === signalR.HubConnectionState.Connected) {
                this.connection.stop();
            }
        } catch (error) {
            console.log(error);
        }
    }

    public isConnectionActive() {
        return this.connection.state === signalR.HubConnectionState.Connected || this.connection.state === signalR.HubConnectionState.Connecting;
    }

    public startConnection() {
        try {
            if (!this.isConnectionActive()) {
                this.connection.start().catch((err) => console.log(err));
            }
        } catch (error) {
            console.log(error);
        }
    }
}
export default WebhookConnector.getInstance;
